var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOffline = function SvgOffline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M4.214 5.719c0 .2.014.397.04.59h-.04v.016a3.183 3.183 0 0 0-.321-.016C2.295 6.309 1 7.497 1 8.963s1.295 2.466 2.893 2.466l5.936-.08m5.937-.08C17.635 10.796 19 9.365 19 7.488c0-2.28-2.015-4.13-4.5-4.13-.224 0-.445.016-.66.045C12.956 1.969 11.28 1 9.357 1a5.42 5.42 0 0 0-3.166 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F55060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M15.063 14.014 2.687 1"
  })));
};
export default SvgOffline;